import React from 'react';
import { useTranslation } from 'react-i18next';
import authService from '../services/authService';

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = async (e) => {
    const newLang = e.target.value;

    // Update frontend
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);

    // Sync with backend if user is authenticated
    const token = authService.getToken();
    if (token) {
      try {
        // Map frontend language code to backend format
        const backendLang = newLang === 'en' ? 'en' : 'es_MX';
        await authService.updatePreferences(token, { language: backendLang });
      } catch (err) {
        console.error('Failed to sync language preference:', err);
      }
    }
  };

  return (
    <select
      aria-label={t('common.language')}
      className="form-select-sm"
      value={i18n.language}
      onChange={handleLanguageChange}
    >
      <option value="en">{t('common.english')}</option>
      <option value="es_MX">{t('common.spanish')}</option>
    </select>
  );
};

export default LanguageSelector;
